import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import { Encabezado } from './Encabezado';

class Becas extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Becas">
                    <section className="paginaItmex">
                        <Encabezado
                            etiqueta="#DonandoBytes"
                            titulo="Programa de Becas"
                            subtitulo="Llevando internet a las escuelas más remotas de Hidalgo."
                        />
                        <div className="paginaItmex-vacio">
                            <span className="beneficiosPaso-icono"><i className="fas fa-graduation-cap"></i></span>
                            <span className="planesItmex-eyebrow">Próximamente</span>
                            <h2>Estamos preparando la nueva edición del programa de becas.</h2>
                            <p>
                                Cada año becamos instituciones educativas y alumnos de comunidades remotas de Hidalgo,
                                acercándoles conectividad y tecnología sin costo. Muy pronto anunciaremos fechas y convocatoria.
                            </p>
                            <div className="heroItmex-actions">
                                <a className="heroItmex-cta paginaItmex-cta-oscuro" href="https://www.facebook.com/itmexoficial" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook-f mr-1"></i> Entérate en Facebook
                                    <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                </a>
                                <Link className="planesItmex-panel-whatsapp paginaItmex-boton-claro" to="/nosotros">Conoce nuestra misión</Link>
                            </div>
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
}
export default Becas;
